import { render, staticRenderFns } from "./DialogConfirmaEnvioDocumentos.vue?vue&type=template&id=6e7c5d1e&scoped=true&"
import script from "./DialogConfirmaEnvioDocumentos.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmaEnvioDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmaEnvioDocumentos.vue?vue&type=style&index=0&id=6e7c5d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c5d1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VRow})
